import { POST } from '@/api'
import { invoke } from 'lodash'
import { setStorage, getStorage, deleteStorage } from '@/utils/localstorageManager'
import { isWebView } from '@/utils/device'

/* ネイティブ mock */
if (STAGE <= STAGE_DEV) {
  require('@/utils/mock').nativeMock('setUserId', 'setPassword')
}

export default {
  namespaced: true,
  state: {
    busy: false,
    error: {
      isError: false,
      title: '',
      massage: '',
    },
    login: {
      mail: '',
      password: '',
      storeName: '',
      token: '',
      saveMail: true,
      tmpId: '',
      tmpPass: '',
      isTemporary: false,
    },
    sendMail: {
      isDirty: false,
      isShowLoading: false,
      isSent: false,
      mail: '',
    },
    account: {
      mailAddress: '',
    },
  },
  mutations: {
    busy(state, busy) {
      state.busy = busy
    },
    updateDialogErrorState(state, flg) {
      state.error.isError = flg
    },
    updateDialogErrorTitle(state, value) {
      state.error.title = value
    },
    updateDialogErrorMessage(state, message) {
      state.error.massage = Array.isArray(message) ? message.join('\n') : message
    },
    set(state, login) {
      state.login = { ...state.login, ...login }
    },
    updateSendmailIsShowLoding(state, flg) {
      state.sendMail.isShowLoading = flg
    },
    updateSendmailIsSent(state, flg) {
      state.sendMail.isSent = flg
    },
    updateSendmailMail(state, value) {
      state.sendMail.mail = value
    },
    updateSendmailIsDirty(state, flg) {
      state.sendMail.isDirty = flg
    },
    regist(state, data) {
      state.account.mailAddress = data.mailAddress
    },
  },
  getters: {
    isDirty: ({ login: { mail, password, tmpId, tmpPass, isTemporary } }) =>
      isTemporary ? tmpId && tmpPass : mail && password,
  },
  actions: {
    init({ commit, dispatch }) {
      // 保存されたメールを入力フォームに反映
      const mail = getStorage('gd-mailAddress')
      if (mail) {
        commit('set', { mail, saveMail: true })
        dispatch('updateSendMail', mail)
      }
    },

    /**
     * ログインチェック
     */
    async checkLogin(store) {
      const {
        commit,
        state: { login, busy },
      } = store
      if (busy) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/login', {
        mail_address: login.mail,
        password: login.password,
      })

      // 異常時
      if (status === 400 && message !== '') {
        commit('updateDialogErrorTitle', 'ログインに失敗しました')
        commit('updateDialogErrorMessage', message)
        commit('updateDialogErrorState', true)
      } else if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      // 正常時
      if (status === 200) {
        commit('set', data)
        // メール保存
        if (login.saveMail) {
          setStorage('gd-mailAddress', login.mail)
          // ログイン状態の保持
          if (isWebView()) {
            invoke(window, 'webkit.messageHandlers.setUserId.postMessage', login.mail)
            invoke(window, 'webkit.messageHandlers.setPassword.postMessage', login.password)
          }
        } else {
          deleteStorage('gd-mailAddress')
        }
      }

      commit('busy', false)
      return status === 200
    },

    async sendResetMail(store) {
      const { state, commit, rootState } = store

      if (state.sendMail.isShowLoading) return
      /*
       * 再設定メール送信
       */
      // ローディング表示
      commit('updateSendmailIsShowLoding', true)
      const { status, message } = await POST('/api/web/password/reset', {
        mail_address: state.sendMail.mail,
        sp: rootState.app.isSP,
      })
      /*
       * 異常時
       */
      if (status === 400 && message !== '') {
        // ローディング非表示 - エラーダイヤログ
        commit('updateSendmailIsShowLoding', false)
        commit('updateDialogErrorTitle', '送信失敗しました')
        commit('updateDialogErrorMessage', message)
        commit('updateDialogErrorState', true)
      } else if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }
      /*
       * 送信完了時
       */
      if (status === 200) {
        // ローディング非表示 - 完了画面遷移
        commit('updateSendmailIsShowLoding', false)
        commit('updateSendmailIsSent', true)
      }
    },
    updateIsError({ commit }, flg) {
      commit('updateDialogErrorState', flg)
    },
    setLoginData({ commit }, value) {
      commit('set', value)
    },
    updateSendMail({ commit, dispatch }, value) {
      commit('updateSendmailMail', value)
      dispatch('checkSendMailDirty')
    },
    checkSendMailDirty({ commit, state }) {
      const isDirty = !(state.sendMail.mail === '')
      commit('updateSendmailIsDirty', isDirty)
    },
    async tmpRegist({ commit, state }, { mailAddress, password, passwordConfirm, sp }) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/account/regist/tmp', {
        token: state.login.token,
        mail_address: mailAddress,
        password,
        password_confirm: passwordConfirm,
        sp,
      })

      // 正常時
      if (status === 200) {
        commit('regist', data)
      }

      // 異常時
      if (status === 400 && message !== '') {
        commit('updateDialogErrorTitle', '登録に失敗しました')
        commit('updateDialogErrorMessage', message)
        commit('updateDialogErrorState', true)
      } else if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async regist({ commit, state }, token) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/account/regist', { token })
      if (status === 200) {
        commit('regist', data)
      } else if (status === 500) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async tmpLogin(store) {
      const {
        commit,
        state: { login, busy },
      } = store

      if (busy) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/tmp_account/auth', {
        id: login.tmpId,
        password: login.tmpPass,
      })

      if (status === 200) {
        commit('set', { token: data.token, storeName: data.storeName })
      }

      // 異常時
      if (status === 400 && message !== '') {
        commit('updateDialogErrorTitle', '登録に失敗しました')
        commit('updateDialogErrorMessage', message)
        commit('updateDialogErrorState', true)
      } else if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
